export enum UserRole {
    Admin = 'admin',
    DataboxAdmin = 'databox-admin',
}
